import { render, staticRenderFns } from "./cont_main.vue?vue&type=template&id=3a89ffd8&scoped=true"
import script from "./cont_main.vue?vue&type=script&lang=js"
export * from "./cont_main.vue?vue&type=script&lang=js"
import style0 from "./cont_main.vue?vue&type=style&index=0&id=3a89ffd8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a89ffd8",
  null
  
)

export default component.exports